const SIGN_OUT_POPUP = {
    ID: 'signout-from-all-devices',
};

function processPopup(html: string, css: string, hidden?: boolean) {
    const styles = `${
        hidden ? 'display: none;' : ''
    } position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 9999999999; display:flex; align-items:center; justify-content:center; height:100%;
    background-color: rgba(0, 0, 0, 0.5);backdrop-filter: blur(7px);
    `;

    const wrapper = `<div style="${styles}" id='${SIGN_OUT_POPUP.ID}' class='bootstrap-popup'>${html}<style>${css}</style></div>`;

    return wrapper.replace(/(\n | \s)/g, '');
}

export { processPopup, SIGN_OUT_POPUP };
